import styled from 'styled-components';

export const MainWrapper = styled.div.attrs(() => ({
  className: 'main-wrapper',
}))`
  display: flex;
  padding: 20px 0;
  width: 100%;
  flex-grow: 1;

  > div {
    flex-grow: 1;
  }

  @media (min-width: 768px) {
    padding-top: 36px;
  }

  @media (max-width: 767px) {
    padding: 21px 0 25px;
  }
`;
